import { Toaster as Sonner, toast, type ToasterProps } from 'sonner';

export { toast };

/**
 * Wraps the Sonner Toaster so toasts remain interactive even when a Radix Dialog
 * (modal) is open. Two issues are addressed:
 *
 * 1. Radix modals set `pointer-events: none` on `document.body`, which would
 *    make toasts unclickable. We counter this with `pointerEvents: 'auto'`.
 *
 * 2. Radix's DismissableLayer listens for `pointerdown` on `document` to detect
 *    outside clicks. Without the wrapper, clicking a toast close button bubbles
 *    up and Radix treats it as an outside click, closing the modal. The wrapper
 *    `div` stops propagation so the event never reaches Radix's listener.
 */
export const Toaster = (props: ToasterProps) => (
  <div
    onPointerDown={e => e.stopPropagation()}
    style={{ pointerEvents: 'auto' }}
  >
    <Sonner
      position="bottom-center"
      style={
        {
          '--toast-icon-margin-end': '1rem',
        } as React.CSSProperties
      }
      closeButton
      duration={15000}
      {...props}
    />
  </div>
);
